<template>
    <div class="mb-5">
        <h3>{{ $t("overviews.ordersOverviewFull") }}</h3>
        <div class="row mb-3 align-items-center">
            <div class="col-2">
                <label class="control-label">{{ $t("overviews.from") }}</label>
            </div>
            <div class="col-2">
                <label class="control-label">{{ $t("overviews.to") }}</label>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-2">
                <input type="date" v-model="from" :max="to" class="form-control" />
            </div>
            <div class="col-2">
                <input type="date" v-model="to" :min="from" class="form-control" />
            </div>
            <div class="col-2">
                <button class="btn button-top" @click="download()">{{ $t("overviews.download") }}</button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            to: new Date(),
            from: null,
        }
    },
    created: function () {
        this.to = this.getDateFormatted(new Date());
        var from = new Date();
        from.setMonth(from.getMonth() - 1);
        this.from = this.getDateFormatted(from);
    },
    methods: {
        getDateFormatted: function (date) {
            return date.getFullYear() + "-" + (date.getMonth() + 1).toString().padStart(2, '0') + "-" + date.getDate().toString().padStart(2, '0');
        },
        download: function () {
            this.$store.getters.api.get('/stats_orders_extended', {
                params: { to: this.to, from: this.from },
                responseType: 'blob' }).then(function (response) {
                const href = URL.createObjectURL(response.data);

                // create "a" HTML element with href to file & click
                const link = document.createElement('a');
                link.href = href;
                //create default name
                link.setAttribute('download', 'produkty_kompletní.xlsx');
                document.body.appendChild(link);
                link.click();

                // clean up "a" element & remove ObjectURL
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            }.bind(this));
        }
    }
}
</script>
<style scoped lang="scss">
@media (min-width: 992px) {
  .col-lg-6 {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }
}
</style>